export default "__VITE_ASSET__Beo66AQt__"